const btn = document.getElementById("nav-button-menu");
const drawer = document.getElementById("drawer");
const area = document.getElementById("header-fixed-area");

btn.addEventListener("click", (e) => {
  e.preventDefault();
  btn.classList.toggle("is-open");
  drawer.classList.toggle("is-open");
  area.classList.toggle("is-drawer-open");
});

window.addEventListener("scroll", () => {
  posY = window.pageYOffset;
  if (posY != 0) {
    area.classList.add("is-moved");
  } else {
    area.classList.remove("is-moved");
  }
});